import React from 'react';
import { CircularProgressProps } from '../../service/interfaces/Components';

const CircularProgress: React.FC<CircularProgressProps> = ({ 
  startDate, 
  endDate, 
  currentDate, 
  totalDays 
}) => {
  const calculateProgress = () => {
    // If dates are provided, use date-based calculation
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const current = currentDate ? new Date(currentDate) : new Date();
      
      // Calculate total days between start and end
      const totalDuration = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
      
      // Calculate days elapsed from start to current
      const daysElapsed = Math.ceil((current.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
      
      // Calculate remaining days
      const daysRemaining = Math.max(0, totalDuration - daysElapsed);
      
      // Calculate progress percentage
      const progressPercentage = Math.min(100, Math.max(0, (daysElapsed / totalDuration) * 100));
      
      return {
        displayNumber: daysRemaining,
        progress: progressPercentage,
        totalDays: totalDuration
      };
    }
    
    // Fallback to original logic for backward compatibility
    if (totalDays) {
      const displayNumber = totalDays;
      const progress = 0;
      return { displayNumber, progress, totalDays };
    }
    
    // Default case
    return { displayNumber: 0, progress: 0, totalDays: 0 };
  };

  const { displayNumber, progress } = calculateProgress();
  
  const radius = 30;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className="relative w-12 h-12">
      <svg
        className="transform -rotate-90 w-12 h-12"
        viewBox="0 0 80 80"
      >
        <circle
          cx="40"
          cy="40"
          r={radius}
          fill="none"
          stroke="#FF8A3D"
          strokeWidth="6"
          strokeDasharray={progress > 0 ? circumference : 0}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
        />
        {progress === 0 && (
          <circle
            cx="40"
            cy="40"
            r={radius}
            fill="none"
            stroke="#FF8A3D"
            strokeWidth="6"
            strokeLinecap="round"
          />
        )}
      </svg>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-[600] font-poppins text-[14px]">
        {String(displayNumber).padStart(2, '0')}
      </div>
    </div>
  );
};

export default CircularProgress;